import { render, staticRenderFns } from "./personAlert.vue?vue&type=template&id=656b160c"
import script from "./personAlert.vue?vue&type=script&lang=js"
export * from "./personAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports